// Get account status types
export const GET_PAYONEER_ACCOUNT_STATUS_INPROGRESS = "GET_PAYONEER_ACCOUNT_STATUS_INPROGRESS";
export const GET_PAYONEER_ACCOUNT_STATUS_FAILURE = "GET_PAYONEER_ACCOUNT_STATUS_FAILURE";
export const GET_PAYONEER_ACCOUNT_STATUS_SUCCESS = "GET_PAYONEER_ACCOUNT_STATUS_SUCCESS";

// Get account balances types
export const GET_PAYONEER_ACCOUNT_BALANCES_INPROGRESS = "GET_PAYONEER_ACCOUNT_BALANCES_INPROGRESS";
export const GET_PAYONEER_ACCOUNT_BALANCES_FAILURE = "GET_PAYONEER_ACCOUNT_BALANCES_FAILURE";
export const GET_PAYONEER_ACCOUNT_BALANCES_SUCCESS = "GET_PAYONEER_ACCOUNT_BALANCES_SUCCESS";

// Get onboarding uri
export const GENERATE_PAYONEER_ONBOARDING_URI_INPROGRESS = "GENERATE_PAYONEER_ONBOARDING_URI_INPROGRESS";
export const GENERATE_PAYONEER_ONBOARDING_URI_FAILURE = "GENERATE_PAYONEER_ONBOARDING_URI_FAILURE";
export const GENERATE_PAYONEER_ONBOARDING_URI_SUCCESS = "GENERATE_PAYONEER_ONBOARDING_URI_SUCCESS";

// // Get account balances types
// export const GET_PAYONEER_ACCOUNT_BALANCES_INPROGRESS = "GET_PAYONEER_ACCOUNT_BALANCES_INPROGRESS";
// export const GET_PAYONEER_ACCOUNT_BALANCES_FAILURE = "GET_PAYONEER_ACCOUNT_BALANCES_FAILURE";
// export const GET_PAYONEER_ACCOUNT_BALANCES_SUCCESS = "GET_VIRTUAL_ACCOUNT_BALANCES_SUCCESS";


// Link Payoneer user to Kuda
export const LINK_PAYONEER_USER_TO_KUDA_INPROGRESS = "LINK_PAYONEER_USER_TO_KUDA_INPROGRESS";
export const LINK_PAYONEER_USER_TO_KUDA_FAILURE = "LINK_PAYONEER_USER_TO_KUDA_FAILURE";
export const LINK_PAYONEER_USER_TO_KUDA_SUCCESS = "LINK_PAYONEER_USER_TO_KUDA_SUCCESS";

// Get account balances types
export const GET_PAYONEER_TRANSACTION_HISTORY_INPROGRESS = "GET_PAYONEER_TRANSACTION_HISTORY_INPROGRESS";
export const GET_PAYONEER_TRANSACTION_HISTORY_FAILURE = "GET_PAYONEER_TRANSACTION_HISTORY_FAILURE";
export const GET_PAYONEER_TRANSACTION_HISTORY_SUCCESS = "GET_PAYONEER_TRANSACTION_HISTORY_SUCCESS";


// Get receiving accounts
export const GET_PAYONEER_RECEIVING_ACCOUNTS_INPROGRESS = "GET_PAYONEER_RECEIVING_ACCOUNTS_INPROGRESS";
export const GET_PAYONEER_RECEIVING_ACCOUNTS_FAILURE = "GET_PAYONEER_RECEIVING_ACCOUNTS_FAILURE";
export const GET_PAYONEER_RECEIVING_ACCOUNTS_SUCCESS = "GET_PAYONEER_RECEIVING_ACCOUNTS_SUCCESS";
